export enum CrmEventType {
	TradeShow = 0,
	Conference = 10,
	Networking = 20,
	CustomerVisit = 30,
	InternalMeeting = 40,
	Other = 50,
	FactoryTour = 60,
	Webinar = 70,
	Awards = 80,
}
